import { LegalPage, Section } from "./LegalLayout";

export default function Terms({ C, onBack }) {
  return (
    <LegalPage C={C} onBack={onBack} title="Términos y Condiciones" updated="22 de julio de 2026">
      <Section C={C} title="1. Aceptación del servicio">
        Al crear una cuenta y usar CuadraAI aceptas estos Términos y Condiciones. Si no estás de acuerdo,
        te pedimos no utilizar la aplicación.
      </Section>

      <Section C={C} title="2. Responsabilidad del usuario">
        Eres responsable de la exactitud de la información financiera, de inventario y de ventas que registras.
        CuadraAI es una herramienta de apoyo para la gestión de tu negocio, no un asesor financiero o contable.
      </Section>

      <Section C={C} title="3. Uso permitido">
        Debes usar CuadraAI únicamente para fines lícitos relacionados con la gestión de tu propio negocio.
        No está permitido intentar vulnerar la seguridad de la plataforma ni acceder a cuentas de otros usuarios.
      </Section>

      <Section C={C} title="4. Suspensión de cuentas">
        Podemos suspender o cancelar cuentas que incumplan estos términos, que representen un riesgo de seguridad,
        o que hagan un uso indebido del servicio.
      </Section>

      <Section C={C} title="5. Limitación de responsabilidad">
        CuadraAI se ofrece "tal cual". No garantizamos que el servicio esté libre de interrupciones o errores,
        y no somos responsables por decisiones de negocio tomadas a partir de la información de la plataforma.
      </Section>

      <Section C={C} title="6. Actualizaciones">
        Podemos actualizar estos términos periódicamente. Si los cambios son significativos, te lo notificaremos
        dentro de la aplicación.
      </Section>

      <Section C={C} title="7. Contacto">
        Si tienes preguntas sobre estos términos, escríbenos a soporte@cuadraai.com.
      </Section>
    </LegalPage>
  );
}
